import o from "./floatWindow.ce.vue2.js";
import t from "./floatWindow.ce.vue3.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const _ = /* @__PURE__ */ r(o, [["styles", [t]]]);
export {
  _ as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/float-window/floatWindow.ce.vue.js
// module id = 1288
// module chunks = 67